import { BaseInput } from "shared/components/forms/BaseInput";
import { type CredentialFormProps } from "./types";

export const RevelaCredentialForm = ({ register }: CredentialFormProps) => (
  <BaseInput
    id="revela_subdomain"
    label="Revela Subdomain"
    placeholder="Enter subdomain"
    {...register("revela_subdomain")}
    required
  />
);
